module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Register"
  }, [_c('form', {
    staticClass: "Register_form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveUser($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.school_loading) ? _c('p', {
    staticClass: "app-simple-loader"
  }) : _vm._e(), _vm._v(" "), (!_vm.school_loading) ? [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_user.school),
      expression: "new_user.school"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.new_user, "school", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('register.field.school')))]), _vm._v(" "), _vm._l((_vm.schools), function(school) {
    return _c('option', {
      key: school.id,
      domProps: {
        "value": school
      }
    }, [_vm._v("\n                " + _vm._s(school.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), (!_vm.new_user.school) ? _vm._m(3) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.new_user.school) ? [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "field column"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('div', {
    staticClass: "select",
    class: {
      'is-danger': _vm.$v.new_user.league.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_user.league),
      expression: "new_user.league"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.new_user, "league", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('register.field.league')))]), _vm._v(" "), _vm._l((_vm.new_user.school.leagues), function(league) {
    return _c('option', {
      key: league.id,
      domProps: {
        "value": league.id
      }
    }, [_vm._v("\n                  " + _vm._s(league.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.league.$error && !_vm.$v.new_user.league.required),
      expression: "$v.new_user.league.$error && !$v.new_user.league.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('validation.required')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "field column"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.new_user.promo),
      expression: "new_user.promo",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.new_user.promo.$error
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('register.field.promo')
    },
    domProps: {
      "value": (_vm.new_user.promo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_user, "promo", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.promo.$error && !_vm.$v.new_user.promo.required),
      expression: "$v.new_user.promo.$error && !$v.new_user.promo.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('validation.required')) + "\n          ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.promo.$error && !_vm.$v.new_user.promo.exactLength),
      expression: "$v.new_user.promo.$error && !$v.new_user.promo.exactLength"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('validation.size.string', {
    size: 4
  })) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "field column"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_user.firstname),
      expression: "new_user.firstname"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.new_user.firstname.$error
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('register.field.firstname')
    },
    domProps: {
      "value": (_vm.new_user.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_user, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.firstname.$error && !_vm.$v.new_user.firstname.required),
      expression: "$v.new_user.firstname.$error && !$v.new_user.firstname.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('validation.required')) + "\n          ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.firstname.$error && !_vm.$v.new_user.firstname.maxLength),
      expression: "$v.new_user.firstname.$error && !$v.new_user.firstname.maxLength"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('validation.max.string', {
    max: 190
  })) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "field column"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_user.lastname),
      expression: "new_user.lastname"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.new_user.lastname.$error
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('register.field.lastname')
    },
    domProps: {
      "value": (_vm.new_user.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_user, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.lastname.$error && !_vm.$v.new_user.lastname.required),
      expression: "$v.new_user.lastname.$error && !$v.new_user.lastname.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('validation.required')) + "\n          ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.lastname.$error && !_vm.$v.new_user.lastname.maxLength),
      expression: "$v.new_user.lastname.$error && !$v.new_user.lastname.maxLength"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('validation.max.string', {
    max: 190
  })) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_user.email),
      expression: "new_user.email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.new_user.email.$error
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('register.field.email')
    },
    domProps: {
      "value": (_vm.new_user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.email.$error && !_vm.$v.new_user.email.required),
      expression: "$v.new_user.email.$error && !$v.new_user.email.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('validation.required')) + "\n        ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.email.$error && !_vm.$v.new_user.email.email),
      expression: "$v.new_user.email.$error && !$v.new_user.email.email"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('validation.email')) + "\n        ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.email.$error && !_vm.$v.new_user.email.maxLength),
      expression: "$v.new_user.email.$error && !$v.new_user.email.maxLength"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('validation.max.string', {
    max: 190
  })) + "\n        ")]), _vm._v(" "), (_vm.enrollment_is_email) ? _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.email.$error && !_vm.$v.new_user.email.enrollment),
      expression: "$v.new_user.email.$error && !$v.new_user.email.enrollment"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('validation.school_email', {
    school: _vm.new_user.school.enrollment_rule
  })) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_user.password),
      expression: "new_user.password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.new_user.password.$error
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('register.field.password')
    },
    domProps: {
      "value": (_vm.new_user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.password.$error && !_vm.$v.new_user.password.required),
      expression: "$v.new_user.password.$error && !$v.new_user.password.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('validation.required')) + "\n        ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_user.password.$error && !_vm.$v.new_user.password.minLength),
      expression: "$v.new_user.password.$error && !$v.new_user.password.minLength"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('validation.min.string', {
    min: 8
  })) + "\n        ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button is-danger is-fullwidth",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('buttons.register')) + "\n        ")])])] : _vm._e()], 2), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.registered,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.registered = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', {
    staticClass: "modal-card-head"
  }, [_c('h1', {
    staticClass: "modal-card-title"
  }, [_vm._v("Bravo !")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.registered = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content content"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "title": _vm.$t('title')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo_small.svg"),
      "alt": _vm.$t('title')
    }
  })])], 1)
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('register.form_text'))
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("school")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('register.no_school')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-danger",
    attrs: {
      "href": "https://docs.google.com/forms/d/e/1FAIpQLSdV8fDG_u4auTCNUGr-RpgTCu5m-eKsdRLnCcffBNvlSVLU6A/viewform",
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.add_my_school')) + "    \n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("school")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("school")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock_outline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": require("../assets/img/illus/share.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "Register_intro"
  }, [_c('p', {
    staticClass: "Register_intro_actions has-text-centered"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('register.already_account')))]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-primary",
    attrs: {
      "to": {
        'name': 'login'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.login')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content has-text-centered"
  }, [_vm._m(10), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('register.title')))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('register.description'))
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v(_vm._s(_vm.$t('modals.registered.title')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modals.registered.text'))
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbdc0b9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageRegister.vue
// module id = 367
// module chunks = 9